import { PeriodRequest } from '@src/api/types/communityDashboard';

export interface DateRangePreset {
  key: PeriodRequest;
  label: string;
}

export const DATE_RANGE_PRESETS: DateRangePreset[] = [
  { key: '7', label: '過去7日間' },
  { key: '30', label: '過去30日間' },
  { key: '90', label: '過去90日間' },
  { key: '365', label: '過去365日間' },
  { key: 'all', label: '全期間（最古〜昨日）' },
  { key: 'custom', label: 'カスタム指定' },
];

export const getPresetByKey = (key: PeriodRequest | null): DateRangePreset => {
  return DATE_RANGE_PRESETS.find((preset) => preset.key === key) || DATE_RANGE_PRESETS[0];
};
